export const scrollToId = (id) => (e) => {
    if (e) e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.5 });
    else el.scrollIntoView({ behavior: "smooth", block: "start" });
};
